import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SubscriptionTeamUpdateInput } from '../generated/globalTypes';
import { updateSubscriptionTeamMutation, updateSubscriptionTeamMutationVariables } from '../generated/updateSubscriptionTeamMutation';
import { subscriptionTeamFieldsFragment } from '../models/SubscriptionTeam';

/**
 * Get a callback to update a SubscriptionTeam in the store.
 */
export function useUpdateSubscriptionTeamCallback(): [(id: string, model: SubscriptionTeamUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateSubscriptionTeamMutation, updateSubscriptionTeamMutationVariables>(
        gql`
            mutation updateSubscriptionTeamMutation ($model: SubscriptionTeamUpdateInput!) {
                updateSubscriptionTeam(model: $model) {
                    ...subscriptionTeamFields
                }
            }

            ${subscriptionTeamFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: SubscriptionTeamUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
